export type SessionSpecialty = 'rheumatology' | 'general_practice' | 'dermatology';

/** Normalize JWT / stored specialty strings onto dest Session.specialty values. */
export function normalizeSessionSpecialty(raw?: string | null): SessionSpecialty {
  const key = String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/[-\s]+/g, '_');
  if (
    key === 'gp' ||
    key === 'general_practice' ||
    key === 'general_practitioner'
  ) {
    return 'general_practice';
  }
  if (key === 'dermatology' || key === 'dermatologist') {
    return 'dermatology';
  }
  return 'rheumatology';
}

export function isDermatologySpecialty(raw?: string | null): boolean {
  return normalizeSessionSpecialty(raw) === 'dermatology';
}

export type DoctorSpecialty = 'Rheumatology' | 'Dermatology' | 'GP';

export const DOCTOR_SPECIALTY_OPTIONS: { value: DoctorSpecialty; label: string }[] = [
  { value: 'Rheumatology', label: 'Rheumatology' },
  { value: 'Dermatology', label: 'Dermatology' },
  { value: 'GP', label: 'General Practice' },
];

export function toDoctorSpecialty(raw?: string | null): DoctorSpecialty | null {
  const key = String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/[-\s]+/g, '_');
  if (!key) return null;
  if (key === 'rheumatology') return 'Rheumatology';
  if (key === 'dermatology' || key === 'dermatologist') return 'Dermatology';
  if (key === 'gp' || key === 'general_practice' || key === 'general_practitioner') return 'GP';
  return null;
}

export function doctorSpecialtyLabel(raw?: string | null): string {
  const match = toDoctorSpecialty(raw);
  return DOCTOR_SPECIALTY_OPTIONS.find((o) => o.value === match)?.label ?? 'Not set';
}

/** A classic protocol's specialty in words: NULL is universal, 'unclassified' an unknown legacy family. */
export function protocolSpecialtyLabel(raw?: string | null): string {
  if (raw === 'unclassified') return 'Needs classification';
  return raw ? doctorSpecialtyLabel(raw) : 'All specialties';
}

/** Explicit assignments take precedence; only legacy accounts fall back to the scalar. */
export function doctorSpecialties(account?: { specialties?: string[]; specialty?: string | null } | null): DoctorSpecialty[] {
  const values = account?.specialties ?? [account?.specialty];
  return Array.from(new Set(values.map(toDoctorSpecialty).filter((value): value is DoctorSpecialty => value !== null)));
}
